import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EecImageModalComponent } from '~shared/modules/energy-label/components';
import { MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [EecImageModalComponent],
  imports: [CommonModule, MmIconModule, MatDialogModule, TranslateModule, MmFlexLayoutModule],
  exports: [],
})
export class EnergyLabelModule {}
